import React from "react";
import { useNavigate } from "react-router-dom"; 
import hand from "../assets/hand.webp";
import insurance from "../assets/insurance.webp";
import wallet from "../assets/wallet.webp";

const services = [
  { 
    img: hand, 
    label: "Loan",
    route: "/allTypeloan" 
  },
  { 
    img: insurance, 
    label: "Insurance",
    route: "/alltypeinsurance" 
  },
  { 
    img: wallet, 
    label: "Payment",
    route: "/alltypepayment" 
  },
];

const Explore = () => {
  const navigate = useNavigate();

  const handleServiceClick = (route) => {
    navigate(route);
  };

  return (
    <div className="container">
      <div className="text-center mb-5">
        <h2 className="fw-semibold mb-4 mt-5">Explore Our Service</h2>
        <h5 className="text-muted col-sm fs-6" style={{ color: "#616161" }}>
          Our goal is to provide easy-to-use, transparent financial products <br />
          that cater to India's rapidly evolving financial needs.
        </h5>
      </div>

      <div className="custom-box mx-auto" style={{ width: "60%" }}>
        <div className="row justify-content-center">
          {services.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 mb-4">
              <div 
                className="hover-box-1 service-card" 
                onClick={() => handleServiceClick(item.route)}
                style={{ cursor: "pointer" }}
              >
                <div className="image-wrapper">
                  <img
                    src={item.img}
                    alt={`${item.label} Service`}
                    className="hover-image-1"
                  />
                </div>
                <div className="hover-label-1 mb-3">{item.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Explore;